module.exports = __webpack_public_path__ + "img/rugby-dark.fef7bdf1.svg";